import React, { ReactElement } from 'react';
import { isEmpty } from 'lodash';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/messages';
import { translate } from 'containers/services/translate';
import { IVictimExpertise } from 'containers/common/LegalProceedings/ExpertReport/typings';
import { VictimType } from 'typings/globalTypes';

export interface ExpertiseVictimsProps {
  intl: IntlShape;
  victims: VictimType[] | IVictimExpertise[];
  children?: ReactElement | ReactElement[];
}

const ExpertiseVictims: React.FC<ExpertiseVictimsProps> = (
  props,
): JSX.Element => {
  const { victims } = props;

  return (
    <section className="list-container">
      <article className="list-title">
        {!isEmpty(victims) && translate(messages.victims, props)}
      </article>
      <article className="expertise-items">{props.children}</article>
    </section>
  );
};

export default injectIntl(ExpertiseVictims);
